import { PublicFiscalYearDTO } from "./publicFiscalYearDto";
import { PublicAccountDTO } from "./publicAccountDto";
import { PublicCurrencyDTO } from "./publicCurrencyDto";
import { PublicSubledgerAccountDTO } from "./publicSubledgerAccountDto";
import { PublicThirdPartiesDTO } from "./publicThirdPartiesDto";

export interface MainStateInfos {
  displayFormulas?: boolean;
  companyList?: Array<PublicFiscalYearDTO>;
  accountList?: Array<PublicAccountDTO>;
  currencyList?: Array<PublicCurrencyDTO>;
  subledgerList?: Array<PublicSubledgerAccountDTO>;
  thirdPartyList?: Array<PublicThirdPartiesDTO>;
}
